import BaseMovement from './Base'
import PlayerMoveToWithSpeed from './PlayerMoveToWithSpeed'
import {randomInteger} from '../helper'

export default class BrownianMovement extends BaseMovement {
    constructor(entity, duration = null) {
        super(entity, entity.CurrentPosition);
        this.MaxDuration = duration;
        this.BrownianSpeed = 10;
        this.CurrentStep = null;
        this.CenterPosition = {Top: entity.CurrentPosition.Top, Left: entity.CurrentPosition.Left};
    }

    Play(gameSpeed) {
        if(this.MaxDuration != null) {
            this.timerId = setTimeout(() => { 
                this.Cancell();
                this.onCancell('timeout');
            }, gameSpeed*this.MaxDuration);
        }
        
        return new Promise(function(resolve, reject) {
            this.resolve = resolve;
            this.move(gameSpeed);
        }.bind(this));
    }

    move(gameSpeed) {
        this.littleStep(gameSpeed).then(() => this.move(gameSpeed)).catch((res)=> {
            if(res == 'cancelled')
                this.onCancell('cancelled');
        });
    }

    onCancell(res){
        this.resolve(res);
    }
    
    littleStep(gameSpeed) {
            
        let maxLeft = 2;
        let maxTop = 2;

        let new_position = { Top: this.CenterPosition.Top + randomInteger(-maxTop, maxTop), Left: this.CenterPosition.Left + randomInteger(-maxLeft, maxTop)};
                    
        this.CurrentStep = new PlayerMoveToWithSpeed(this.Entity, this.BrownianSpeed, new_position);
        return this.CurrentStep.Play(gameSpeed);
    }

    Cancell(){
        if(this.timerId != null)
            clearTimeout(this.timerId);
        
        if(this.CurrentStep != null){
            this.CurrentStep.Cancell();
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Movements/BrownianMovement.js
 **/